// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"c3dfa888","242":"fe87cbfb","623":"30213fd8","738":"b180dba5","821":"f44ec36a","926":"8c1c7f7f","962":"55879e6b"}[chunkId] + ".css";
};